import { render, staticRenderFns } from "./SalesPersonModal.vue?vue&type=template&id=35350974&"
import script from "./SalesPersonModal.vue?vue&type=script&lang=js&"
export * from "./SalesPersonModal.vue?vue&type=script&lang=js&"
import style0 from "./SalesPersonModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports